import _default from './Rail';
export { _default as default };